export const ProfileDefaultViewTypeValues = ['classic', 'timeline'];
//# sourceMappingURL=profile-default-view-type.js.map